import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { getStyles, translate } from '../../../shared/utility';

import TextClamp from '../../UI/TextClamp/TextClamp';
import Button from '../../UI/Button/Button';
import Icon from '../../UI/Icon/Icon';
import Submenu from './SubMenu/SubMenu';

import userPlaceholder from '../../../assets/images/img-contact-placeholder.svg';

import localStyles from './Menu.scss';
const styles = getStyles(localStyles);

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: props.menu || 'user'
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeMenu !== this.state.activeMenu && this.state.activeMenu === 'payment' && !this.props.paymentAccountsData.length) {
            this.props.onFetchPaymentAccounts();
        }
    }

    setActiveMenu = (newMenu) => {
        if (this.state.activeMenu !== newMenu) {
            this.setState({ activeMenu: newMenu });
        }
    }

    handlePageRedirect = () => {
        if (this.props.isMenuOpen) {
            this.props.onSetGlobalState('isMenuOpen', false);
        }
    }

    /* * * * * * *
     * NAV ITEMS *
     * * * * * * */
    getNavItems = (type, items = [], addPaymentAccountDisplay = false) => {
        const navItems = items.map((item, index) => {
            if (item.submenu) {
                item.click = () => this.setActiveMenu(item.submenu);
            }
            item.index = Number.isInteger(item.index) ? item.index : index;
            return item;
        }).sort((a, b) => a.index >= b.index ? 1 : -1);

        const navItemContentClasses = ['menu__content', 'flex', 'flex--align-center', 'flex--justify-between'];

        const paymentAccountsDisplay = addPaymentAccountDisplay ? (
            <li className={styles('menu__item', `${type}__item`)}>
                <div className={styles(navItemContentClasses)}>
                    <img
                        className={styles('menu__image', 'menu__image--contain', 'menu__image--border', 'circle')}
                        src={this.props.paymentAccountDetailsData && this.props.paymentAccountDetailsData.imageReference ? this.props.paymentAccountDetailsData.imageReference.source : userPlaceholder}
                        alt="" />
                    <p className={styles('menu__text', 'line-height--small')}>
                        <strong className={styles('menu__text__block')}>
                            <TextClamp lines={2}>{this.props.userData.name}</TextClamp>
                        </strong>
                        <span className={styles('c--text-light')}>{this.props.paymentAccountDetailsData ? this.props.paymentAccountDetailsData.accountType : 'No default'}</span>
                    </p>
                    <Button
                        classes={styles('menu__button')}
                        events={{ click: () => this.setActiveMenu('payment') }}
                        modifiers={['xs', 'square']}
                        icon={'arrow-right'}
                    />
                </div>
            </li>
        ) : null;

        return (
            <Fragment>
                {paymentAccountsDisplay}
                {navItems.map((item, index) => {
                    const innerContent = (
                        <Fragment>
                            {item.icon ? (
                                <div className={styles('menu__image')}>
                                    <Icon classes={styles('menu__icon')} icon={item.icon} modifiers={[this.props.iconSize || 'medium']}/>
                                </div>
                            ) : null}
                            <span className={styles('w--400', 'menu__text')}>
                                {translate(item.title, this.props.language)}
                            </span>
                        </Fragment>
                    );

                    const itemContent = item.path ? (
                        <NavLink to={item.path} onClick={this.handlePageRedirect}
                            className={styles(navItemContentClasses, 'menu__link', `${type}__link`, 'no-text-decoration')}
                            isActive={() => this.props.history.location.pathname.substr(0, item.path.length).toLowerCase() === item.path.toLowerCase()}
                            activeClassName={styles('menu__link--active', `${type}__link--active`)}
                        >
                            {innerContent}
                        </NavLink>
                    ) : item.click ? (
                        <Button
                            classes={styles(navItemContentClasses, 'menu__link', `${type}__link`)}
                            modifiers={['text']}
                            events={{ click: item.click }}
                            iconEnd={item.submenu ? 'arrow-right' : null}
                        >{innerContent}</Button>
                    ) : <div className={styles(navItemContentClasses)}>{innerContent}</div>;

                    return <li className={styles('menu__item', `${type}__item`)} key={index}>{itemContent}</li>;
                })}
            </Fragment>
        );
    }

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        const type = ['dropdown', 'sidemenu'].includes(this.props.type) ? this.props.type : 'sidemenu';
        const parentMenus = {
            'preferences': 'user',
            'payment': 'user',
            'language': 'preferences'
        };

        const subMenuOpen = this.state.activeMenu !== 'user' && this.state.activeMenu !== 'custom';

        const subMenuContent = subMenuOpen ? (
            <Submenu
                menu={this.state.activeMenu}
                goBack={() => this.setActiveMenu(parentMenus[this.state.activeMenu])}
                goBackText={translate('ui.back', this.props.language)}
                title={translate(`menu.${this.state.activeMenu}.title`, this.props.language)}
                description={translate(`menu.${this.state.activeMenu}.description`, this.props.language)}
                pageRedirect={this.handlePageRedirect}
            />
        ) : null;

        const defaultItems = {
            'user': [
                {
                    title: 'menu.user.reservations',
                    icon: 'my-reservations',
                    path: '/reservations/'
                },
                {
                    title: 'menu.user.orders',
                    icon: 'package',
                    path: '/orders/'
                }
            ],
            'preferences': [
                {
                    title: 'menu.preferences.changeLanguage',
                    icon: 'chat',
                    submenu: 'language'
                },
                {
                    title: 'menu.user.profile',
                    icon: 'user',
                    path: '/profile/'
                },
                {
                    title: 'menu.user.paymentPreferences',
                    icon: 'payment',
                    path: '/payment-preferences/'
                }
            ]
        };

        const menuItems = (defaultItems[this.state.activeMenu] || []).concat(!subMenuOpen ? (this.props.items || []) : []);

        const menuContent = menuItems.length ? (
            <ul className={styles('menu', type, 'no-list-style')}>
                {this.getNavItems(type, menuItems, this.state.activeMenu === 'user')}
            </ul>
        ) : null;

        return (
            <Fragment>
                {subMenuContent}
                {menuContent}
            </Fragment>
        );
    }
}

Menu.propTypes = {
    // properties
    history: PropTypes.object.isRequired,
    menu: PropTypes.string,
    type: PropTypes.string,
    iconSize: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),

    userData: PropTypes.object.isRequired,
    paymentAccountDetailsData: PropTypes.object,
    isMenuOpen: PropTypes.bool,
    paymentAccountsData: PropTypes.arrayOf(PropTypes.object),

    paymentAccountsLoading: PropTypes.bool,
    paymentAccountsError: PropTypes.string,

    language: PropTypes.string.isRequired,

    // functions
    onSetGlobalState: PropTypes.func.isRequired,
    onFetchPaymentAccounts: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        userData: state.details.user.data,
        paymentAccountDetailsData: state.details.paymentAccount.data,
        isMenuOpen: state.global.isMenuOpen,
        paymentAccountsData: state.list.paymentAccounts.data,
        paymentAccountsLoading: state.list.paymentAccounts.loading,
        paymentAccountsError: state.list.paymentAccounts.error,

        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value)),
        onFetchPaymentAccounts: () => dispatch(actions.fetchPaymentAccounts()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/Navigation/Menu/Menu.js